export const RUTGERS_SCHOOL_CODES_SOURCE_URL = 'https://finance.rutgers.edu/student-abc/school-codes';

export type RutgersSchoolCode = {
  code: string;
  campus: 'New Brunswick' | 'Newark' | 'Camden' | 'Rutgers Biomedical and Health Sciences';
  name: string;
};

const SCHOOL_CODES: RutgersSchoolCode[] = [
  { code: '01', campus: 'New Brunswick', name: 'School of Arts and Sciences' },
  { code: '07', campus: 'New Brunswick', name: 'Mason Gross School of the Arts' },
  { code: '08', campus: 'New Brunswick', name: 'Graduate Mason Gross School of the Arts' },
  { code: '10', campus: 'New Brunswick', name: 'Edward J. Bloustein School of Planning and Public Policy: Undergraduate' },
  { code: '11', campus: 'New Brunswick', name: 'School of Environmental and Biological Sciences' },
  { code: '14', campus: 'New Brunswick', name: 'School of Engineering' },
  { code: '15', campus: 'New Brunswick', name: 'Graduate School of Education' },
  { code: '16', campus: 'New Brunswick', name: 'School of Graduate Studies–New Brunswick' },
  { code: '17', campus: 'New Brunswick', name: 'School of Communication and Information' },
  { code: '18', campus: 'New Brunswick', name: 'Graduate School of Applied and Professional Psychology' },
  { code: '19', campus: 'New Brunswick', name: 'Graduate School of Social Work' },
  { code: '30', campus: 'New Brunswick', name: 'Ernest Mario School of Pharmacy' },
  { code: '31', campus: 'New Brunswick', name: 'Graduate School of Pharmacy' },
  { code: '33', campus: 'New Brunswick', name: 'School of Business' },
  { code: '34', campus: 'New Brunswick', name: 'Edward J. Bloustein School of Planning and Public Policy: Graduate' },
  { code: '37', campus: 'New Brunswick', name: 'School of Management and Labor Relations: Undergraduate' },
  { code: '38', campus: 'New Brunswick', name: 'School of Management and Labor Relations: Graduate' },
  { code: '77', campus: 'New Brunswick', name: 'School of Nursing' },
  { code: '80', campus: 'New Brunswick', name: 'Continuous Education' },
  { code: '81', campus: 'New Brunswick', name: 'Graduate Continuous Education' },
  { code: '20', campus: 'Newark', name: 'School of Public Affairs and Administration' },
  { code: '21', campus: 'Newark', name: 'Newark College of Arts and Sciences' },
  { code: '22', campus: 'Newark', name: 'Rutgers Business School–Newark' },
  { code: '23', campus: 'Newark', name: 'Rutgers School of Law–Newark' },
  { code: '25', campus: 'Newark', name: 'School of Nursing' },
  { code: '26', campus: 'Newark', name: 'Graduate School–Newark' },
  { code: '27', campus: 'Newark', name: 'School of Criminal Justice: Graduate' },
  { code: '29', campus: 'Newark', name: 'Business School' },
  { code: '40', campus: 'Newark', name: 'Public Affairs & Administration' },
  { code: '45', campus: 'Newark', name: 'Graduate Nursing' },
  { code: '47', campus: 'Newark', name: 'School of Criminal Justice' },
  { code: '62', campus: 'Newark', name: 'University College–Newark' },
  { code: '24', campus: 'Camden', name: 'Rutgers School of Law–Camden' },
  { code: '50', campus: 'Camden', name: 'Camden College of Arts and Sciences' },
  { code: '52', campus: 'Camden', name: 'School of Business–Camden' },
  { code: '53', campus: 'Camden', name: 'Graduate School of Business' },
  { code: '56', campus: 'Camden', name: 'Graduate School–Camden' },
  { code: '57', campus: 'Camden', name: 'School of Nursing–Camden' },
  { code: '58', campus: 'Camden', name: 'Graduate School of Nursing' },
  { code: '64', campus: 'Camden', name: 'University College–Camden' },
  { code: 'MN', campus: 'Rutgers Biomedical and Health Sciences', name: 'New Jersey Medical School' },
  { code: 'RW', campus: 'Rutgers Biomedical and Health Sciences', name: 'Robert Wood Johnson Medical School' },
  { code: 'DS', campus: 'Rutgers Biomedical and Health Sciences', name: 'Rutgers School of Dental Medicine' },
  { code: 'GN', campus: 'Rutgers Biomedical and Health Sciences', name: 'School of Graduate Studies (Newark)' },
  { code: 'GP', campus: 'Rutgers Biomedical and Health Sciences', name: 'School of Graduate Studies (Piscataway)' },
  { code: 'HP', campus: 'Rutgers Biomedical and Health Sciences', name: 'School of Health Professions' },
  { code: 'SN', campus: 'Rutgers Biomedical and Health Sciences', name: 'School of Nursing (Newark & New Brunswick)' },
  { code: 'PH', campus: 'Rutgers Biomedical and Health Sciences', name: 'School of Public Health' },
];

const SCHOOL_CODE_MAP = new Map(SCHOOL_CODES.map((school) => [school.code, school]));

export function getRutgersSchoolCode(code: string): RutgersSchoolCode | null {
  return SCHOOL_CODE_MAP.get(code.trim().toUpperCase().padStart(2, '0')) ?? null;
}

export function formatRutgersSchoolLabel(code: string): string {
  const school = getRutgersSchoolCode(code);
  if (!school) return `School ${code}`;
  const campusPrefix = school.name.toLowerCase().includes(school.campus.toLowerCase()) ? '' : `${school.campus} `;
  return `School ${school.code} — ${campusPrefix}${school.name}`;
}

export const RUTGERS_SCHOOL_CODES = SCHOOL_CODES;
